import { GzAntimalwareOnDemandDeviceScanFormWebComponent } from './component/GzAntimalwareOnDemandDeviceScanFormWebComponent';

export { GzAntimalwareOnDemandDeviceScanFormWebComponent };
